export const setListagemMapaLeitos = (state, payload) => {
  state.listagemMapaLeitos = payload;
};

export const updateLeito = (state, payload) => {
    let index = state.listagemMapaLeitos.dados.findIndex((i) => i.leitoId == payload.leitoId)
    state.listagemMapaLeitos.dados.splice(index, 1, payload)
};

export const desativarLeito = (state, payload) => {
    let index = state.listagemMapaLeitos.dados.findIndex((i) => i.leitoId == payload.id)
    state.listagemMapaLeitos.dados.splice(index, 1)
};

export const ativarLeito = (state, payload) => {
    let index = state.listagemMapaLeitos.dados.findIndex((i) => i.leitoCodigoEnfermaria == payload.leitoCodigoEnfermaria)
    if (index >= 0) state.listagemMapaLeitos.dados.splice(index, 0, payload)
    else state.listagemMapaLeitos.dados.splice(state.listagemMapaLeitos.dados.length, 0, payload)
};

export const inserirLeito = (state, payload) => {
    let index = state.listagemMapaLeitos.dados.findIndex((i) => i.leitoCodigoEnfermaria == payload.leitoCodigoEnfermaria)
    if (index >= 0) state.listagemMapaLeitos.dados.splice(index, 0, payload)
    else state.listagemMapaLeitos.dados.splice(state.listagemMapaLeitos.dados.length, 0, payload)
};

export const updateAihs = (state, payload) => {
    let index = state.listagemMapaLeitos.dados.findIndex((i) => i.leitoId == payload[0].idLeito)
    state.listagemMapaLeitos.dados[index]['aih'] = payload
};

export const setListagemFiltradaStatus = (state, payload) => {
  state.listagemFiltradaStatus = payload;
};

export const setOpcoesSelect = (state, payload) => {
  state.opcoesSelect = payload;
};

export const setListagemFiltrada = (state, payload) => {
  state.listagemFiltrada = payload;
};

